<template>
  <div class="post-slider-900">
    <m-content-wrapper content-type="post">
      <template v-slot="{contents}">
        <swiper class="mySwiper py-4 w-100 "
                v-bind="swiperOptions" :pagination="true" :navigation="true" :modules="modules">

          <template v-for="content in contents" :key="content.id">
            <swiper-slide class="py-3">

              <m-a v-if="cardLink" :href="{name:'SinglePost',params:{slug:content.slug}}">
                <component :is="postCard" :content="content"/>
              </m-a>
              <component v-else :is="postCard" :content="content"/>


            </swiper-slide>
          </template>


        </swiper>
      </template>
    </m-content-wrapper>
  </div>
</template>

<script>
import mContentWrapper from "../../Wrappers/ContentWrapper.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import {EffectFade, Navigation} from "swiper";
import {postSliderProps} from "./PostSliderProps";
import mA from '../../Tags/A.vue'
import {Cards} from "../Card/Cards";
import {Pagination} from 'swiper';

export default {
  name: "PostSlider900",
  components: {Swiper, SwiperSlide, mContentWrapper, mA, ...Cards},
  props: {
    ...postSliderProps
  },
  data() {
    return {
      swiperOptions: {
        spaceBetween: 30,
        breakpoints: {
          300: {
            slidesPerView: 2,
          },
          400: {
            slidesPerView: 3,
          },
          430: {
            slidesPerView: 3,
          },
          490: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
          520: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
          768: {
            slidesPerView: 6,
            spaceBetween: 50,
          },
          980: {
            slidesPerView: 8,
          },
          1200: {
            slidesPerView: 8,

          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    }
  },
  setup() {
    return {
      modules: [Navigation, EffectFade, Pagination],
    };
  },
  beforeMount() {

    this.swiperOptions.breakpoints["300"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["400"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["430"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["490"].slidesPerView = this.swiperPerViewSM

    this.swiperOptions.breakpoints["520"].slidesPerView = this.swiperPerViewMD
    this.swiperOptions.breakpoints["768"].slidesPerView = this.swiperPerViewMD

    this.swiperOptions.breakpoints["980"].slidesPerView = this.swiperPerViewLG
    this.swiperOptions.breakpoints["1200"].slidesPerView = this.swiperPerViewLG

  }
}
</script>


<style scoped>

</style>